import { useState, useEffect } from 'react';

const DARK_MODE_CLASS = 'awsui-polaris-dark-mode';

export const useDarkMode = (): boolean => {
	const [isDarkMode, setIsDarkMode] = useState(
		() => document.body.classList.contains(DARK_MODE_CLASS)
	);

	useEffect(() => {
		const observer = new MutationObserver(() => {
			setIsDarkMode(document.body.classList.contains(DARK_MODE_CLASS));
		});
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
		return () => observer.disconnect();
	}, []);

	return isDarkMode;
};
